// extracted by mini-css-extract-plugin
export default {"summaryItem":"CensusSummary_summaryItem__6snuN","summaryWrap":"CensusSummary_summaryWrap__CPMlj","details":"CensusSummary_details__5FTY0"};